import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridCategoriesComponent } from './grid-categories.component';
import { CarouselModule } from 'primeng/carousel';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { CustomBannerModule } from '../banner/banner.module';
import { ScreenViewModule } from '../../../../../../core/directives/screen-view/_screen-view.module';
import {GenericLinkModule} from "@spartacus/storefront";

@NgModule({
  declarations: [GridCategoriesComponent],
  imports: [CommonModule, CarouselModule, CustomBannerModule, ScreenViewModule, GenericLinkModule],
  providers: [
    provideConfig(<CmsConfig>{
      cmsComponents: {
        GridCategories: {
          component: GridCategoriesComponent,
        },
      },
    }),
  ],
  exports: [GridCategoriesComponent],
})
export class GridCategoriesModule {}
